module.exports = __webpack_public_path__ + "img/22f.d4955552.png";